import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const iconPrimaryMd = cn(shared.iconMd, shared.iconPrimary);

const cardHeaderIcon = iconPrimaryMd;

const discordHeader = cn(shared.rowGap2, "mb-4");

const discordIcon = iconPrimaryMd;

const scheduleHeader = cn(shared.rowGap2, "mb-1");

const scheduleIcon = iconPrimaryMd;

const section = "space-y-6";

const card = "rounded-xl border border-border bg-card shadow-card transition-all duration-200 hover:border-primary/30 p-4 sm:p-6";

const headerRow = cn(shared.rowBetween, "mb-4");

const settingItem = "space-y-2 text-sm text-muted-foreground";

const form = "flex flex-col gap-3 max-w-md mt-4";

const input =
  "w-full rounded-lg border bg-background px-3 py-2 text-sm border-border focus:outline-none focus:ring-2 focus:ring-ring placeholder:text-muted-foreground/60 disabled:opacity-50";

const select =
  "w-full rounded-lg border bg-background px-3 py-2 text-sm border-border focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50";

const saveButton =
  "self-start rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:pointer-events-none mt-2";

const cancelButton =
  "rounded-lg border border-border bg-background text-muted-foreground px-4 py-2 text-sm font-medium hover:bg-accent transition-colors disabled:opacity-50 disabled:pointer-events-none mt-2";

const addBankButton =
  "inline-flex items-center gap-1.5 rounded-lg bg-primary/10 text-primary px-3 py-1.5 text-xs font-semibold hover:bg-primary/20 transition-colors border border-border/60";

const bankList = "space-y-3 mt-4";

const cardHeaderRow = cn(shared.rowGap3, "flex-1");

const bankCard = "rounded-lg border bg-card p-4 border-border space-y-3";

const bankName = "text-sm font-semibold text-foreground shrink-0 min-w-[80px]";

const setDefaultButton =
  "rounded-lg border border-border bg-background text-muted-foreground px-3 py-1.5 text-xs font-medium hover:bg-accent transition-colors disabled:opacity-50 disabled:pointer-events-none ml-auto shrink-0";

const deleteButton =
  "inline-flex items-center gap-1.5 rounded-lg border border-destructive/20 bg-destructive/5 text-destructive px-3 py-1.5 text-xs font-medium hover:bg-destructive/10 transition-colors disabled:opacity-50 disabled:pointer-events-none";

const editButton =
  "inline-flex items-center gap-1.5 rounded-lg border border-border bg-background text-muted-foreground px-3 py-1.5 text-xs font-medium hover:bg-accent transition-colors disabled:opacity-50 disabled:pointer-events-none";

const addForm = "space-y-3 max-w-md mt-4 p-4 rounded-lg border bg-card/80 border-border";

const inputWrapper = "relative";

const inputIconPadding = "pl-9";

const formActions = "flex gap-2 self-start mt-1";

const bankDefaultIcon = "text-success shrink-0";

const actionButtonRow = "flex items-center gap-2 mt-3 pt-3 border-t border-border/60 justify-end";

const logoWrapper = "inline-flex items-center";

const logoImg = "h-10 w-auto max-w-[4.5rem] object-contain";

const defaultRow = "flex items-center gap-1.5";

const bankSelectLogo = logoImg;

export {
  addBankButton,
  actionButtonRow,
  addForm,
  bankCard,
  bankList,
  bankName,
  cancelButton,
  card,
  cardHeaderIcon,
  cardHeaderRow,
  deleteButton,
  discordHeader,
  discordIcon,
  editButton,
  form,
  formActions,
  headerRow,
  input,
  inputIconPadding,
  inputWrapper,
  bankDefaultIcon,
  logoImg,
  bankSelectLogo,
  defaultRow,
  logoWrapper,
  saveButton,
  section,
  select,
  settingItem,
  setDefaultButton,
  scheduleHeader,
  scheduleIcon,
};
